const vars = {
    subdomain: "cosmos-diagram",
    protocol: "https://",
    webSite : "cosmos-diagram.usversoft.com",
    baseWebSite: "usversoft.com",
    emailDomain : "https://usversoft.com/",
    authDodmain: "https://auth.usversoft.com/"
}
export default vars;